import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Http from 'services/http2';
import User from 'services/user2';
import AreaCode from 'components/areaCode';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

const styles = theme => ({
  button: {
    width: '100%',
    height: '50px',
    fontSize: '16px',
  },
});

class Login extends Component {
  constructor(props) {
    super(props);
    this.postdata = {};
    this.timer = 0;
    this.state = {
      isDisplayCaptcha: false,
      rd: 0,
      responseMsg: null,
      error: null,
      path: null,
    };
  }

  init() {
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    this.init();
  }

  //输入框值变化时清空当前error
  handleInput = (e, key) => {
    this.postdata[key] = e.target.value;
    if (this.state.responseMsg !== null) {
      this.setState({ responseMsg: null });
    }
  };

  areaCodeChange = code => {
    this.postdata['mobileArea'] = code;
  };

  changeCaptch = () => {
    if (this.timer !== undefined) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      this.setState({ rd: Math.random() });
    }, 800);
  };

  login = () => {
    let postbody = Object.assign(this.postdata, {
      apiPath: '/sysUser/login',
      captcha: this.state.isDisplayCaptcha ? this.postdata.captcha : undefined,
    });
    Http.post('/api/mp', postbody).then(response => {
      if (response.success) {
        let userInfo = response.data.sysUser;
        let companyList = response.data.companyList;
        User.setUserInfo(userInfo);
        User.setCompanyList(companyList);
        User.initDefaultCompany();
        User.getMenuAuth();
        this.props.history.push('/mp/index');
      } else {
        if (response.isDisplayCaptcha) {
          this.setState({ isDisplayCaptcha: response.isDisplayCaptcha });
        }
        this.setState({ responseMsg: response.errorMsg });
      }
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className="page page-login">
        <div className="container">
          <div className="m-logo">
            <img src="/assets/img/logo@2x.png" alt="" />
            <span className="label">登录携客账号</span>
          </div>
          <div className="input-item input-mobile">
            <TextField
              id="outlined-mobile"
              label="手机号"
              className="text-field"
              onChange={e => this.handleInput(e, 'mobile')}
              margin="normal"
              variant="outlined"
            />
            <AreaCode onChange={this.areaCodeChange} />
          </div>
          <div className="input-item">
            <TextField
              id="outlined-password"
              label="密码"
              type="password"
              className="text-field"
              onChange={e => this.handleInput(e, 'password')}
              margin="normal"
              variant="outlined"
            />
          </div>
          {this.state.isDisplayCaptcha && (
            <div className="input-item">
              <TextField
                id="outlined-captcha"
                label="验证码"
                className="text-field"
                onKeyUp={e => this.handleInput(e, 'captcha')}
                margin="normal"
                variant="outlined"
              />
              <img
                title="点击换一张"
                src={'/captcha/' + this.state.rd}
                onClick={this.changeCaptch}
                alt="点击重试"
                className="captcha"
              />
            </div>
          )}
          {this.state.responseMsg && (
            <p className="error-tip">{this.state.responseMsg}</p>
          )}
          <div className="input-item">
            <Button
              variant="contained"
              color="primary"
              onClick={this.login}
              className={classes.button}
            >
              登 陆
            </Button>
          </div>
          <div className="input-item tr">
            还没有账号？
            <Link to="/mp/register">免费注册</Link>
          </div>
        </div>
        {/* <h3>绑定携客账号</h3>
        <div>
          <AreaCode onChange={this.areaCodeChange}/>
          <input type="text" name="mobile" onKeyUp={e => this.handleInput(e, 'mobile')} autoComplete="tel-local" placeholder="请输入手机号" />
        </div>
        <div>
          <input type="password" name="password" onKeyUp={e => this.handleInput(e, 'password')} autoComplete="off" placeholder="请输入密码" />
        </div>

        {this.state.isDisplayCaptcha && <div>
              <input type="text" name="captcha" onKeyUp={e => this.handleInput(e, 'captcha')} placeholder="请输入右侧验证码" />
              <img title="点击换一张" src={'/captcha/' + this.state.rd} onClick={this.changeCaptch} alt="点击重试" />
            </div>}

        {this.state.responseMsg && <p><ErrorIcon color="secondary"/>{this.state.responseMsg}</p>}
        <div>
          <input type="submit" onClick={this.login} value="登 陆" />
        </div>
        <div>
          <span>
            还没有账号？<Link to="/mp/register">免费注册</Link>
          </span>
        </div> */}
      </div>
    );
  }
}

export default withStyles(styles)(Login);
